const NUM_PICKUP = 1;
const NUM_DELIVERY = 2;

export default {
  NUM_PICKUP,
  NUM_DELIVERY
};
